(function webpackUniversalModuleDefinition(root, factory) {
  if (typeof exports === 'object' && typeof module === 'object') module.exports = factory(require("react"), require("classnames"), require("@material/react-ripple/dist/index.js"));else if (typeof define === 'function' && define.amd) define(["react", "classnames", "@material/react-ripple/dist/index.js"], factory);else {
    var a = typeof exports === 'object' ? factory(require("react"), require("classnames"), require("@material/react-ripple/dist/index.js")) : factory(root["react"], root["classnames"], root["@material/react-ripple/dist/index.js"]);

    for (var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
  }
})(typeof self !== 'undefined' ? self : this, function (__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__) {
  return (
    /******/
    function (modules) {
      // webpackBootstrap

      /******/
      // The module cache

      /******/
      var installedModules = {};
      /******/

      /******/
      // The require function

      /******/

      function __webpack_require__(moduleId) {
        /******/

        /******/
        // Check if module is in cache

        /******/
        if (installedModules[moduleId]) {
          /******/
          return installedModules[moduleId].exports;
          /******/
        }
        /******/
        // Create a new module (and put it into the cache)

        /******/


        var module = installedModules[moduleId] = {
          /******/
          i: moduleId,

          /******/
          l: false,

          /******/
          exports: {}
          /******/

        };
        /******/

        /******/
        // Execute the module function

        /******/

        modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/

        /******/
        // Flag the module as loaded

        /******/

        module.l = true;
        /******/

        /******/
        // Return the exports of the module

        /******/

        return module.exports;
        /******/
      }
      /******/

      /******/

      /******/
      // expose the modules object (__webpack_modules__)

      /******/


      __webpack_require__.m = modules;
      /******/

      /******/
      // expose the module cache

      /******/

      __webpack_require__.c = installedModules;
      /******/

      /******/
      // define getter function for harmony exports

      /******/

      __webpack_require__.d = function (exports, name, getter) {
        /******/
        if (!__webpack_require__.o(exports, name)) {
          /******/
          Object.defineProperty(exports, name, {
            /******/
            configurable: false,

            /******/
            enumerable: true,

            /******/
            get: getter
            /******/

          });
          /******/
        }
        /******/

      };
      /******/

      /******/
      // getDefaultExport function for compatibility with non-harmony modules

      /******/


      __webpack_require__.n = function (module) {
        /******/
        var getter = module && module.__esModule ?
        /******/
        function getDefault() {
          return module['default'];
        } :
        /******/
        function getModuleExports() {
          return module;
        };
        /******/

        __webpack_require__.d(getter, 'a', getter);
        /******/


        return getter;
        /******/
      };
      /******/

      /******/
      // Object.prototype.hasOwnProperty.call

      /******/


      __webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/

      /******/
      // __webpack_public_path__

      /******/


      __webpack_require__.p = "";
      /******/

      /******/
      // Load entry module and return exports

      /******/

      return __webpack_require__(__webpack_require__.s = 67);
      /******/
    }(
    /************************************************************************/

    /******/
    {
      /***/
      0:
      /***/
      function _(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_0__;
        /***/
      },

      /***/
      1:
      /***/
      function _(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_1__;
        /***/
      },

      /***/
      2:
      /***/
      function _(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_2__;
        /***/
      },

      /***/
      31:
      /***/
      function _(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        /* harmony export (immutable) */

        __webpack_exports__["b"] = __extends;
        /* harmony export (binding) */

        __webpack_require__.d(__webpack_exports__, "a", function () {
          return _assign;
        });
        /* unused harmony export __rest */

        /* unused harmony export __decorate */

        /* unused harmony export __param */

        /* unused harmony export __metadata */

        /* unused harmony export __awaiter */

        /* unused harmony export __generator */

        /* unused harmony export __exportStar */

        /* unused harmony export __values */

        /* unused harmony export __read */

        /* unused harmony export __spread */

        /* unused harmony export __await */

        /* unused harmony export __asyncGenerator */

        /* unused harmony export __asyncDelegator */

        /* unused harmony export __asyncValues */

        /* unused harmony export __makeTemplateObject */

        /* unused harmony export __importStar */

        /* unused harmony export __importDefault */


        var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
          return typeof obj;
        } : function (obj) {
          return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        /*! *****************************************************************************
        Copyright (c) Microsoft Corporation. All rights reserved.
        Licensed under the Apache License, Version 2.0 (the "License"); you may not use
        this file except in compliance with the License. You may obtain a copy of the
        License at http://www.apache.org/licenses/LICENSE-2.0
        THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
        KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
        WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
        MERCHANTABLITY OR NON-INFRINGEMENT.
        See the Apache Version 2.0 License for specific language governing permissions
        and limitations under the License.
        ***************************************************************************** */

        /* global Reflect, Promise */


        var _extendStatics = function extendStatics(d, b) {
          _extendStatics = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (d, b) {
            d.__proto__ = b;
          } || function (d, b) {
            for (var p in b) {
              if (b.hasOwnProperty(p)) d[p] = b[p];
            }
          };

          return _extendStatics(d, b);
        };

        function __extends(d, b) {
          _extendStatics(d, b);

          function __() {
            this.constructor = d;
          }

          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        }

        var _assign = function __assign() {
          _assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];

              for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
              }
            }

            return t;
          };

          return _assign.apply(this, arguments);
        };

        function __rest(s, e) {
          var t = {};

          for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
          }

          if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
          }
          return t;
        }

        function __decorate(decorators, target, key, desc) {
          var c = arguments.length,
              r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
              d;
          if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
            if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
          }
          return c > 3 && r && Object.defineProperty(target, key, r), r;
        }

        function __param(paramIndex, decorator) {
          return function (target, key) {
            decorator(target, key, paramIndex);
          };
        }

        function __metadata(metadataKey, metadataValue) {
          if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
        }

        function __awaiter(thisArg, _arguments, P, generator) {
          return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) {
              try {
                step(generator.next(value));
              } catch (e) {
                reject(e);
              }
            }

            function rejected(value) {
              try {
                step(generator["throw"](value));
              } catch (e) {
                reject(e);
              }
            }

            function step(result) {
              result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
              }).then(fulfilled, rejected);
            }

            step((generator = generator.apply(thisArg, _arguments || [])).next());
          });
        }

        function __generator(thisArg, body) {
          var _ = {
            label: 0,
            sent: function sent() {
              if (t[0] & 1) throw t[1];
              return t[1];
            },
            trys: [],
            ops: []
          },
              f,
              y,
              t,
              g;
          return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
          }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
            return this;
          }), g;

          function verb(n) {
            return function (v) {
              return step([n, v]);
            };
          }

          function step(op) {
            if (f) throw new TypeError("Generator is already executing.");

            while (_) {
              try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];

                switch (op[0]) {
                  case 0:
                  case 1:
                    t = op;
                    break;

                  case 4:
                    _.label++;
                    return {
                      value: op[1],
                      done: false
                    };

                  case 5:
                    _.label++;
                    y = op[1];
                    op = [0];
                    continue;

                  case 7:
                    op = _.ops.pop();

                    _.trys.pop();

                    continue;

                  default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                      _ = 0;
                      continue;
                    }

                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                      _.label = op[1];
                      break;
                    }

                    if (op[0] === 6 && _.label < t[1]) {
                      _.label = t[1];
                      t = op;
                      break;
                    }

                    if (t && _.label < t[2]) {
                      _.label = t[2];

                      _.ops.push(op);

                      break;
                    }

                    if (t[2]) _.ops.pop();

                    _.trys.pop();

                    continue;
                }

                op = body.call(thisArg, _);
              } catch (e) {
                op = [6, e];
                y = 0;
              } finally {
                f = t = 0;
              }
            }

            if (op[0] & 5) throw op[1];
            return {
              value: op[0] ? op[1] : void 0,
              done: true
            };
          }
        }

        function __exportStar(m, exports) {
          for (var p in m) {
            if (!exports.hasOwnProperty(p)) exports[p] = m[p];
          }
        }

        function __values(o) {
          var m = typeof Symbol === "function" && o[Symbol.iterator],
              i = 0;
          if (m) return m.call(o);
          return {
            next: function next() {
              if (o && i >= o.length) o = void 0;
              return {
                value: o && o[i++],
                done: !o
              };
            }
          };
        }

        function __read(o, n) {
          var m = typeof Symbol === "function" && o[Symbol.iterator];
          if (!m) return o;
          var i = m.call(o),
              r,
              ar = [],
              e;

          try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
              ar.push(r.value);
            }
          } catch (error) {
            e = {
              error: error
            };
          } finally {
            try {
              if (r && !r.done && (m = i["return"])) m.call(i);
            } finally {
              if (e) throw e.error;
            }
          }

          return ar;
        }

        function __spread() {
          for (var ar = [], i = 0; i < arguments.length; i++) {
            ar = ar.concat(__read(arguments[i]));
          }

          return ar;
        }

        function __await(v) {
          return this instanceof __await ? (this.v = v, this) : new __await(v);
        }

        function __asyncGenerator(thisArg, _arguments, generator) {
          if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
          var g = generator.apply(thisArg, _arguments || []),
              i,
              q = [];
          return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () {
            return this;
          }, i;

          function verb(n) {
            if (g[n]) i[n] = function (v) {
              return new Promise(function (a, b) {
                q.push([n, v, a, b]) > 1 || resume(n, v);
              });
            };
          }

          function resume(n, v) {
            try {
              step(g[n](v));
            } catch (e) {
              settle(q[0][3], e);
            }
          }

          function step(r) {
            r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
          }

          function fulfill(value) {
            resume("next", value);
          }

          function reject(value) {
            resume("throw", value);
          }

          function settle(f, v) {
            if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
          }
        }

        function __asyncDelegator(o) {
          var i, p;
          return i = {}, verb("next"), verb("throw", function (e) {
            throw e;
          }), verb("return"), i[Symbol.iterator] = function () {
            return this;
          }, i;

          function verb(n, f) {
            i[n] = o[n] ? function (v) {
              return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
              } : f ? f(v) : v;
            } : f;
          }
        }

        function __asyncValues(o) {
          if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
          var m = o[Symbol.asyncIterator],
              i;
          return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () {
            return this;
          }, i);

          function verb(n) {
            i[n] = o[n] && function (v) {
              return new Promise(function (resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
              });
            };
          }

          function settle(resolve, reject, d, v) {
            Promise.resolve(v).then(function (v) {
              resolve({
                value: v,
                done: d
              });
            }, reject);
          }
        }

        function __makeTemplateObject(cooked, raw) {
          if (Object.defineProperty) {
            Object.defineProperty(cooked, "raw", {
              value: raw
            });
          } else {
            cooked.raw = raw;
          }

          return cooked;
        }

        ;

        function __importStar(mod) {
          if (mod && mod.__esModule) return mod;
          var result = {};
          if (mod != null) for (var k in mod) {
            if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
          }
          result.default = mod;
          return result;
        }

        function __importDefault(mod) {
          return mod && mod.__esModule ? mod : {
            default: mod
          };
        }
        /***/

      },

      /***/
      32:
      /***/
      function _(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        /* harmony export (binding) */

        __webpack_require__.d(__webpack_exports__, "a", function () {
          return MDCFoundation;
        });
        /**
         * @license
         * Copyright 2016 Google Inc.
         *
         * Permission is hereby granted, free of charge, to any person obtaining a copy
         * of this software and associated documentation files (the "Software"), to deal
         * in the Software without restriction, including without limitation the rights
         * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
         * copies of the Software, and to permit persons to whom the Software is
         * furnished to do so, subject to the following conditions:
         *
         * The above copyright notice and this permission notice shall be included in
         * all copies or substantial portions of the Software.
         *
         * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
         * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
         * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
         * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
         * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
         * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
         * THE SOFTWARE.
         */


        var MDCFoundation =
        /** @class */
        function () {
          function MDCFoundation(adapter) {
            if (adapter === void 0) {
              adapter = {};
            }

            this.adapter_ = adapter;
          }

          Object.defineProperty(MDCFoundation, "cssClasses", {
            get: function get() {
              // Classes extending MDCFoundation should implement this method to return an object which exports every
              // CSS class the foundation class needs as a property. e.g. {ACTIVE: 'mdc-component--active'}
              return {};
            },
            enumerable: true,
            configurable: true
          });
          Object.defineProperty(MDCFoundation, "strings", {
            get: function get() {
              // Classes extending MDCFoundation should implement this method to return an object which exports all
              // semantic strings as constants. e.g. {ARIA_ROLE: 'tablist'}
              return {};
            },
            enumerable: true,
            configurable: true
          });
          Object.defineProperty(MDCFoundation, "numbers", {
            get: function get() {
              // Classes extending MDCFoundation should implement this method to return an object which exports all
              // of its semantic numbers as constants. e.g. {ANIMATION_DELAY_MS: 350}
              return {};
            },
            enumerable: true,
            configurable: true
          });
          Object.defineProperty(MDCFoundation, "defaultAdapter", {
            get: function get() {
              // Classes extending MDCFoundation may choose to implement this getter in order to provide a convenient
              // way of viewing the necessary methods of an adapter. In the future, this could also be used for adapter
              // validation.
              return {};
            },
            enumerable: true,
            configurable: true
          });

          MDCFoundation.prototype.init = function () {// Subclasses should override this method to perform initialization routines (registering events, etc.)
          };

          MDCFoundation.prototype.destroy = function () {// Subclasses should override this method to perform de-initialization routines (de-registering events, etc.)
          };

          return MDCFoundation;
        }(); // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.

        /* unused harmony default export */


        var _unused_webpack_default_export = MDCFoundation;
        /***/
      },

      /***/
      33:
      /***/
      function _(module, exports, __webpack_require__) {
        "use strict";

        var __extends = this && this.__extends || function () {
          var _extendStatics2 = function extendStatics(d, b) {
            _extendStatics2 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (d, b) {
              d.__proto__ = b;
            } || function (d, b) {
              for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
            };

            return _extendStatics2(d, b);
          };

          return function (d, b) {
            _extendStatics2(d, b);

            function __() {
              this.constructor = d;
            }

            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }();

        var __importDefault = this && this.__importDefault || function (mod) {
          return mod && mod.__esModule ? mod : {
            "default": mod
          };
        };

        Object.defineProperty(exports, "__esModule", {
          value: true
        }); // The MIT License
        //
        // Copyright (c) 2018 Google, Inc.
        //
        // Permission is hereby granted, free of charge, to any person obtaining a copy
        // of this software and associated documentation files (the "Software"), to deal
        // in the Software without restriction, including without limitation the rights
        // to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
        // copies of the Software, and to permit persons to whom the Software is
        // furnished to do so, subject to the following conditions:
        //
        // The above copyright notice and this permission notice shall be included in
        // all copies or substantial portions of the Software.
        //
        // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
        // IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
        // FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
        // AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
        // LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
        // OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
        // THE SOFTWARE.

        var react_1 = __importDefault(__webpack_require__(0));

        var ChipCheckmark =
        /** @class */
        function (_super) {
          __extends(ChipCheckmark, _super);

          function ChipCheckmark() {
            var _this = _super !== null && _super.apply(this, arguments) || this;

            _this.width = 0;

            _this.init = function (element) {
              if (!element) {
                return;
              } // The checkmark's width may initially be set to 0, so use the checkmark's height as a proxy since the
              // checkmark should always be square.


              _this.width = element.getBoundingClientRect().height;
            };

            return _this;
          }

          ChipCheckmark.prototype.render = function () {
            return react_1.default.createElement("div", {
              className: 'mdc-chip__checkmark',
              ref: this.init
            }, react_1.default.createElement("svg", {
              className: 'mdc-chip__checkmark-svg',
              viewBox: '-2 -3 30 30',
              focusable: 'false'
            }, react_1.default.createElement("path", {
              className: 'mdc-chip__checkmark-path',
              fill: 'none',
              stroke: 'black',
              d: 'M1.73,12.91 8.1,19.28 22.79,4.59'
            })));
          };

          return ChipCheckmark;
        }(react_1.default.Component);

        exports.default = ChipCheckmark;
        /***/
      },

      /***/
      34:
      /***/
      function _(module, exports) {
        // shim for using process in browser
        var process = module.exports = {}; // cached from whatever global is present so that test runners that stub it
        // don't break things.  But we need to wrap it in a try catch in case it is
        // wrapped in strict mode code which doesn't define any globals.  It's inside a
        // function because try/catches deoptimize in certain engines.

        var cachedSetTimeout;
        var cachedClearTimeout;

        function defaultSetTimout() {
          throw new Error('setTimeout has not been defined');
        }

        function defaultClearTimeout() {
          throw new Error('clearTimeout has not been defined');
        }

        (function () {
          try {
            if (typeof setTimeout === 'function') {
              cachedSetTimeout = setTimeout;
            } else {
              cachedSetTimeout = defaultSetTimout;
            }
          } catch (e) {
            cachedSetTimeout = defaultSetTimout;
          }

          try {
            if (typeof clearTimeout === 'function') {
              cachedClearTimeout = clearTimeout;
            } else {
              cachedClearTimeout = defaultClearTimeout;
            }
          } catch (e) {
            cachedClearTimeout = defaultClearTimeout;
          }
        })();

        function runTimeout(fun) {
          if (cachedSetTimeout === setTimeout) {
            //normal enviroments in sane situations
            return setTimeout(fun, 0);
          } // if setTimeout wasn't available but was latter defined


          if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
            cachedSetTimeout = setTimeout;
            return setTimeout(fun, 0);
          }

          try {
            // when when somebody has screwed with setTimeout but no I.E. maddness
            return cachedSetTimeout(fun, 0);
          } catch (e) {
            try {
              // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
              return cachedSetTimeout.call(null, fun, 0);
            } catch (e) {
              // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
              return cachedSetTimeout.call(this, fun, 0);
            }
          }
        }

        function runClearTimeout(marker) {
          if (cachedClearTimeout === clearTimeout) {
            //normal enviroments in sane situations
            return clearTimeout(marker);
          } // if clearTimeout wasn't available but was latter defined


          if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
            cachedClearTimeout = clearTimeout;
            return clearTimeout(marker);
          }

          try {
            // when when somebody has screwed with setTimeout but no I.E. maddness
            return cachedClearTimeout(marker);
          } catch (e) {
            try {
              // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
              return cachedClearTimeout.call(null, marker);
            } catch (e) {
              // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
              // Some versions of I.E. have different rules for clearTimeout vs setTimeout
              return cachedClearTimeout.call(this, marker);
            }
          }
        }

        var queue = [];
        var draining = false;
        var currentQueue;
        var queueIndex = -1;

        function cleanUpNextTick() {
          if (!draining || !currentQueue) {
            return;
          }

          draining = false;

          if (currentQueue.length) {
            queue = currentQueue.concat(queue);
          } else {
            queueIndex = -1;
          }

          if (queue.length) {
            drainQueue();
          }
        }

        function drainQueue() {
          if (draining) {
            return;
          }

          var timeout = runTimeout(cleanUpNextTick);
          draining = true;
          var len = queue.length;

          while (len) {
            currentQueue = queue;
            queue = [];

            while (++queueIndex < len) {
              if (currentQueue) {
                currentQueue[queueIndex].run();
              }
            }

            queueIndex = -1;
            len = queue.length;
          }

          currentQueue = null;
          draining = false;
          runClearTimeout(timeout);
        }

        process.nextTick = function (fun) {
          var args = new Array(arguments.length - 1);

          if (arguments.length > 1) {
            for (var i = 1; i < arguments.length; i++) {
              args[i - 1] = arguments[i];
            }
          }

          queue.push(new Item(fun, args));

          if (queue.length === 1 && !draining) {
            runTimeout(drainQueue);
          }
        }; // v8 likes predictible objects


        function Item(fun, array) {
          this.fun = fun;
          this.array = array;
        }

        Item.prototype.run = function () {
          this.fun.apply(null, this.array);
        };

        process.title = 'browser';
        process.browser = true;
        process.env = {};
        process.argv = [];
        process.version = ''; // empty string to avoid regexp issues

        process.versions = {};

        function noop() {}

        process.on = noop;
        process.addListener = noop;
        process.once = noop;
        process.off = noop;
        process.removeListener = noop;
        process.removeAllListeners = noop;
        process.emit = noop;
        process.prependListener = noop;
        process.prependOnceListener = noop;

        process.listeners = function (name) {
          return [];
        };

        process.binding = function (name) {
          throw new Error('process.binding is not supported');
        };

        process.cwd = function () {
          return '/';
        };

        process.chdir = function (dir) {
          throw new Error('process.chdir is not supported');
        };

        process.umask = function () {
          return 0;
        };
        /***/

      },

      /***/
      67:
      /***/
      function _(module, exports, __webpack_require__) {
        "use strict"; // The MIT License
        //
        // Copyright (c) 2018 Google, Inc.
        //
        // Permission is hereby granted, free of charge, to any person obtaining a copy
        // of this software and associated documentation files (the "Software"), to deal
        // in the Software without restriction, including without limitation the rights
        // to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
        // copies of the Software, and to permit persons to whom the Software is
        // furnished to do so, subject to the following conditions:
        //
        // The above copyright notice and this permission notice shall be included in
        // all copies or substantial portions of the Software.
        //
        // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
        // IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
        // FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
        // AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
        // LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
        // OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
        // THE SOFTWARE.

        var __importDefault = this && this.__importDefault || function (mod) {
          return mod && mod.__esModule ? mod : {
            "default": mod
          };
        };

        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var Chip_1 = __importDefault(__webpack_require__(68));

        exports.Chip = Chip_1.default;

        var ChipCheckmark_1 = __importDefault(__webpack_require__(33));

        exports.ChipCheckmark = ChipCheckmark_1.default;

        var ChipSet_1 = __importDefault(__webpack_require__(71));

        exports.ChipSet = ChipSet_1.default;
        /***/
      },

      /***/
      68:
      /***/
      function _(module, exports, __webpack_require__) {
        "use strict";

        var __extends = this && this.__extends || function () {
          var _extendStatics3 = function extendStatics(d, b) {
            _extendStatics3 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (d, b) {
              d.__proto__ = b;
            } || function (d, b) {
              for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
            };

            return _extendStatics3(d, b);
          };

          return function (d, b) {
            _extendStatics3(d, b);

            function __() {
              this.constructor = d;
            }

            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }();

        var __assign = this && this.__assign || function () {
          __assign = Object.assign || function (t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];

              for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }

            return t;
          };

          return __assign.apply(this, arguments);
        };

        var __rest = this && this.__rest || function (s, e) {
          var t = {};

          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

          if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
          return t;
        };

        var __importDefault = this && this.__importDefault || function (mod) {
          return mod && mod.__esModule ? mod : {
            "default": mod
          };
        };

        Object.defineProperty(exports, "__esModule", {
          value: true
        }); // The MIT License
        //
        // Copyright (c) 2018 Google, Inc.
        //
        // Permission is hereby granted, free of charge, to any person obtaining a copy
        // of this software and associated documentation files (the "Software"), to deal
        // in the Software without restriction, including without limitation the rights
        // to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
        // copies of the Software, and to permit persons to whom the Software is
        // furnished to do so, subject to the following conditions:
        //
        // The above copyright notice and this permission notice shall be included in
        // all copies or substantial portions of the Software.
        //
        // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
        // IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
        // FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
        // AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
        // LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
        // OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
        // THE SOFTWARE.

        var react_1 = __importDefault(__webpack_require__(0));

        var classnames_1 = __importDefault(__webpack_require__(1));

        var react_ripple_1 = __webpack_require__(2);

        var foundation_1 = __webpack_require__(69);

        var Chip =
        /** @class */
        function (_super) {
          __extends(Chip, _super);

          function Chip() {
            var _this = _super !== null && _super.apply(this, arguments) || this;

            _this.chipElement = null;
            _this.state = {
              classList: new Set(),
              leadingIconClassList: new Set()
            };

            _this.init = function (el) {
              _this.chipElement = el;
              _this.props.initRipple && _this.props.initRipple(el);
            };

            _this.onClick = function (e) {
              _this.props.onClick(e);

              _this.foundation.handleInteraction(e.nativeEvent);
            };

            _this.onKeyDown = function (e) {
              _this.props.onKeyDown(e);

              _this.foundation.handleInteraction(e.nativeEvent);
            };

            _this.handleTrailingIconClick = function (e) {
              return _this.foundation.handleTrailingIconInteraction(e.nativeEvent);
            };

            _this.handleTransitionEnd = function (e) {
              _this.props.onTransitionEnd(e);

              _this.foundation.handleTransitionEnd(e.nativeEvent);
            };

            _this.renderLeadingIcon = function (leadingIcon) {
              var leadingIconClassList = _this.state.leadingIconClassList;

              var _a = leadingIcon.props,
                  className = _a.className,
                  otherProps = __rest(_a, ["className"]);

              var props = __assign({
                className: classnames_1.default(className, Array.from(leadingIconClassList), 'mdc-chip__icon', 'mdc-chip__icon--leading')
              }, otherProps);

              return react_1.default.cloneElement(leadingIcon, props);
            };

            _this.renderTrailingIcon = function (trailingIcon) {
              var _a = trailingIcon.props,
                  className = _a.className,
                  otherProps = __rest(_a, ["className"]);

              var props = __assign({
                className: classnames_1.default(className, 'mdc-chip__icon', 'mdc-chip__icon--trailing'),
                onClick: _this.handleTrailingIconClick,
                onKeyDown: _this.handleTrailingIconClick,
                tabIndex: 0,
                role: 'button'
              }, otherProps);

              return react_1.default.cloneElement(trailingIcon, props);
            };

            return _this;
          }

          Chip.prototype.componentDidMount = function () {
            var _a = this.props,
                selected = _a.selected,
                shouldRemoveOnTrailingIconClick = _a.shouldRemoveOnTrailingIconClick;
            this.foundation = new foundation_1.MDCChipFoundation(this.adapter);
            this.foundation.init();
            this.foundation.setSelected(selected);

            if (shouldRemoveOnTrailingIconClick !== this.foundation.getShouldRemoveOnTrailingIconClick()) {
              this.foundation.setShouldRemoveOnTrailingIconClick(shouldRemoveOnTrailingIconClick);
            }
          };

          Chip.prototype.componentDidUpdate = function (prevProps) {
            var _a = this.props,
                selected = _a.selected,
                shouldRemoveOnTrailingIconClick = _a.shouldRemoveOnTrailingIconClick;

            if (selected !== prevProps.selected) {
              this.foundation.setSelected(selected);
            }

            if (shouldRemoveOnTrailingIconClick !== prevProps.shouldRemoveOnTrailingIconClick) {
              this.foundation.setShouldRemoveOnTrailingIconClick(shouldRemoveOnTrailingIconClick);
            }
          };

          Chip.prototype.componentWillUnmount = function () {
            this.foundation.destroy();
          };

          Object.defineProperty(Chip.prototype, "classes", {
            get: function get() {
              var classList = this.state.classList;
              var className = this.props.className;
              return classnames_1.default('mdc-chip', Array.from(classList), className);
            },
            enumerable: true,
            configurable: true
          });
          Object.defineProperty(Chip.prototype, "adapter", {
            get: function get() {
              var _this = this;

              return {
                addClass: function addClass(className) {
                  var classList = new Set(_this.state.classList);
                  classList.add(className);

                  _this.setState({
                    classList: classList
                  });
                },
                removeClass: function removeClass(className) {
                  var classList = new Set(_this.state.classList);
                  classList.delete(className);

                  _this.setState({
                    classList: classList
                  });
                },
                hasClass: function hasClass(className) {
                  return _this.classes.split(' ').includes(className);
                },
                hasLeadingIcon: function hasLeadingIcon() {
                  return Boolean(_this.props.leadingIcon);
                },
                eventTargetHasClass: function eventTargetHasClass(target, className) {
                  return target.classList.contains(className);
                },
                getComputedStyleValue: function getComputedStyleValue(propertyName) {
                  if (!_this.chipElement) return '';
                  return window.getComputedStyle(_this.chipElement).getPropertyValue(propertyName);
                },
                getRootBoundingClientRect: function getRootBoundingClientRect() {
                  if (!_this.chipElement) {
                    // new DOMRect is not IE11 compatible
                    var defaultDOMRect = {
                      bottom: 0,
                      height: 0,
                      left: 0,
                      right: 0,
                      top: 0,
                      width: 0,
                      x: 0,
                      y: 0
                    };
                    return defaultDOMRect;
                  }

                  return _this.chipElement.getBoundingClientRect();
                },
                getCheckmarkBoundingClientRect: function getCheckmarkBoundingClientRect() {
                  var chipCheckmark = _this.props.chipCheckmark;

                  if (!(chipCheckmark && chipCheckmark.props && chipCheckmark.props.getBoundingClientRect)) {
                    // new DOMRect is not IE11 compatible
                    var defaultDOMRect = {
                      bottom: 0,
                      height: 0,
                      left: 0,
                      right: 0,
                      top: 0,
                      width: 0,
                      x: 0,
                      y: 0
                    };
                    return defaultDOMRect;
                  }

                  return chipCheckmark.props.getBoundingClientRect();
                },
                setStyleProperty: function setStyleProperty(propertyName, value) {
                  if (!_this.chipElement) return;

                  _this.chipElement.style.setProperty(propertyName, value);
                },
                notifyRemoval: function notifyRemoval() {
                  return _this.props.handleRemove(_this.props.id);
                },
                notifyInteraction: function notifyInteraction() {
                  return _this.props.handleInteraction(_this.props.id);
                },
                notifySelection: function notifySelection(selected) {
                  return _this.props.handleSelect(_this.props.id, selected);
                },
                notifyTrailingIconInteraction: function notifyTrailingIconInteraction() {
                  return _this.props.handleTrailingIconInteraction(_this.props.id);
                },
                addClassToLeadingIcon: function addClassToLeadingIcon(className) {
                  var leadingIconClassList = new Set(_this.state.leadingIconClassList);
                  leadingIconClassList.add(className);

                  _this.setState({
                    leadingIconClassList: leadingIconClassList
                  });
                },
                removeClassFromLeadingIcon: function removeClassFromLeadingIcon(className) {
                  var leadingIconClassList = new Set(_this.state.leadingIconClassList);
                  leadingIconClassList.delete(className);

                  _this.setState({
                    leadingIconClassList: leadingIconClassList
                  });
                }
              };
            },
            enumerable: true,
            configurable: true
          });

          Chip.prototype.render = function () {
            var _a = this.props,

            /* eslint-disable @typescript-eslint/no-unused-vars */
            id = _a.id,
                className = _a.className,
                selected = _a.selected,
                handleSelect = _a.handleSelect,
                handleInteraction = _a.handleInteraction,
                handleRemove = _a.handleRemove,
                handleTrailingIconInteraction = _a.handleTrailingIconInteraction,
                onClick = _a.onClick,
                onKeyDown = _a.onKeyDown,
                onTransitionEnd = _a.onTransitionEnd,
                computeBoundingRect = _a.computeBoundingRect,
                initRipple = _a.initRipple,
                unbounded = _a.unbounded,
                shouldRemoveOnTrailingIconClick = _a.shouldRemoveOnTrailingIconClick,

            /* eslint-enable @typescript-eslint/no-unused-vars */
            chipCheckmark = _a.chipCheckmark,
                leadingIcon = _a.leadingIcon,
                trailingIcon = _a.trailingIcon,
                label = _a.label,
                otherProps = __rest(_a, ["id", "className", "selected", "handleSelect", "handleInteraction", "handleRemove", "handleTrailingIconInteraction", "onClick", "onKeyDown", "onTransitionEnd", "computeBoundingRect", "initRipple", "unbounded", "shouldRemoveOnTrailingIconClick", "chipCheckmark", "leadingIcon", "trailingIcon", "label"]);

            return react_1.default.createElement("div", __assign({
              tabIndex: 0,
              className: this.classes,
              onClick: this.onClick,
              onKeyDown: this.onKeyDown,
              onTransitionEnd: this.handleTransitionEnd,
              ref: this.init
            }, otherProps), leadingIcon && this.renderLeadingIcon(leadingIcon), chipCheckmark, react_1.default.createElement("div", {
              className: 'mdc-chip__text'
            }, label), trailingIcon && this.renderTrailingIcon(trailingIcon));
          };

          Chip.defaultProps = {
            id: '',
            label: '',
            className: '',
            selected: false,
            onClick: function onClick() {},
            onKeyDown: function onKeyDown() {},
            onTransitionEnd: function onTransitionEnd() {},
            initRipple: function initRipple() {},
            handleSelect: function handleSelect() {},
            handleRemove: function handleRemove() {},
            handleInteraction: function handleInteraction() {},
            handleTrailingIconInteraction: function handleTrailingIconInteraction() {},
            shouldRemoveOnTrailingIconClick: true
          };
          return Chip;
        }(react_1.default.Component);

        exports.Chip = Chip;
        exports.default = react_ripple_1.withRipple(Chip);
        /***/
      },

      /***/
      69:
      /***/
      function _(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        Object.defineProperty(__webpack_exports__, "__esModule", {
          value: true
        });
        /* harmony export (binding) */

        __webpack_require__.d(__webpack_exports__, "MDCChipFoundation", function () {
          return MDCChipFoundation;
        });
        /* harmony import */


        var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(31);
        /* harmony import */


        var __WEBPACK_IMPORTED_MODULE_1__material_base_foundation__ = __webpack_require__(32);
        /* harmony import */


        var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(70);
        /**
         * @license
         * Copyright 2016 Google Inc.
         *
         * Permission is hereby granted, free of charge, to any person obtaining a copy
         * of this software and associated documentation files (the "Software"), to deal
         * in the Software without restriction, including without limitation the rights
         * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
         * copies of the Software, and to permit persons to whom the Software is
         * furnished to do so, subject to the following conditions:
         *
         * The above copyright notice and this permission notice shall be included in
         * all copies or substantial portions of the Software.
         *
         * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
         * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
         * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
         * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
         * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
         * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
         * THE SOFTWARE.
         */


        var emptyClientRect = {
          bottom: 0,
          height: 0,
          left: 0,
          right: 0,
          top: 0,
          width: 0
        };

        var MDCChipFoundation =
        /** @class */
        function (_super) {
          __WEBPACK_IMPORTED_MODULE_0_tslib__["b"
          /* __extends */
          ](MDCChipFoundation, _super);

          function MDCChipFoundation(adapter) {
            var _this = _super.call(this, __WEBPACK_IMPORTED_MODULE_0_tslib__["a"
            /* __assign */
            ]({}, MDCChipFoundation.defaultAdapter, adapter)) || this;
            /**
            * Whether a trailing icon click should immediately trigger exit/removal of the chip.
            */


            _this.shouldRemoveOnTrailingIconClick_ = true;
            return _this;
          }

          Object.defineProperty(MDCChipFoundation, "strings", {
            get: function get() {
              return __WEBPACK_IMPORTED_MODULE_2__constants__["b"
              /* strings */
              ];
            },
            enumerable: true,
            configurable: true
          });
          Object.defineProperty(MDCChipFoundation, "cssClasses", {
            get: function get() {
              return __WEBPACK_IMPORTED_MODULE_2__constants__["a"
              /* cssClasses */
              ];
            },
            enumerable: true,
            configurable: true
          });
          Object.defineProperty(MDCChipFoundation, "defaultAdapter", {
            get: function get() {
              return {
                addClass: function addClass() {
                  return undefined;
                },
                addClassToLeadingIcon: function addClassToLeadingIcon() {
                  return undefined;
                },
                eventTargetHasClass: function eventTargetHasClass() {
                  return false;
                },
                getCheckmarkBoundingClientRect: function getCheckmarkBoundingClientRect() {
                  return emptyClientRect;
                },
                getComputedStyleValue: function getComputedStyleValue() {
                  return '';
                },
                getRootBoundingClientRect: function getRootBoundingClientRect() {
                  return emptyClientRect;
                },
                hasClass: function hasClass() {
                  return false;
                },
                hasLeadingIcon: function hasLeadingIcon() {
                  return false;
                },
                notifyInteraction: function notifyInteraction() {
                  return undefined;
                },
                notifyRemoval: function notifyRemoval() {
                  return undefined;
                },
                notifySelection: function notifySelection() {
                  return undefined;
                },
                notifyTrailingIconInteraction: function notifyTrailingIconInteraction() {
                  return undefined;
                },
                removeClass: function removeClass() {
                  return undefined;
                },
                removeClassFromLeadingIcon: function removeClassFromLeadingIcon() {
                  return undefined;
                },
                setStyleProperty: function setStyleProperty() {
                  return undefined;
                }
              };
            },
            enumerable: true,
            configurable: true
          });

          MDCChipFoundation.prototype.isSelected = function () {
            return this.adapter_.hasClass(__WEBPACK_IMPORTED_MODULE_2__constants__["a"
            /* cssClasses */
            ].SELECTED);
          };

          MDCChipFoundation.prototype.setSelected = function (selected) {
            if (selected) {
              this.adapter_.addClass(__WEBPACK_IMPORTED_MODULE_2__constants__["a"
              /* cssClasses */
              ].SELECTED);
            } else {
              this.adapter_.removeClass(__WEBPACK_IMPORTED_MODULE_2__constants__["a"
              /* cssClasses */
              ].SELECTED);
            }

            this.adapter_.notifySelection(selected);
          };

          MDCChipFoundation.prototype.getShouldRemoveOnTrailingIconClick = function () {
            return this.shouldRemoveOnTrailingIconClick_;
          };

          MDCChipFoundation.prototype.setShouldRemoveOnTrailingIconClick = function (shouldRemove) {
            this.shouldRemoveOnTrailingIconClick_ = shouldRemove;
          };

          MDCChipFoundation.prototype.getDimensions = function () {
            var _this = this;

            var getRootRect = function getRootRect() {
              return _this.adapter_.getRootBoundingClientRect();
            };

            var getCheckmarkRect = function getCheckmarkRect() {
              return _this.adapter_.getCheckmarkBoundingClientRect();
            }; // When a chip has a checkmark and not a leading icon, the bounding rect changes in size depending on the current
            // size of the checkmark.


            if (!this.adapter_.hasLeadingIcon()) {
              var checkmarkRect = getCheckmarkRect();

              if (checkmarkRect) {
                var rootRect = getRootRect(); // Checkmark is a square, meaning the client rect's width and height are identical once the animation completes.
                // However, the checkbox is initially hidden by setting the width to 0.
                // To account for an initial width of 0, we use the checkbox's height instead (which equals the end-state width)
                // when adding it to the root client rect's width.

                return {
                  bottom: rootRect.bottom,
                  height: rootRect.height,
                  left: rootRect.left,
                  right: rootRect.right,
                  top: rootRect.top,
                  width: rootRect.width + checkmarkRect.height
                };
              }
            }

            return getRootRect();
          };
          /**
          * Begins the exit animation which leads to removal of the chip.
          */


          MDCChipFoundation.prototype.beginExit = function () {
            this.adapter_.addClass(__WEBPACK_IMPORTED_MODULE_2__constants__["a"
            /* cssClasses */
            ].CHIP_EXIT);
          };
          /**
          * Handles an interaction event on the root element.
          */


          MDCChipFoundation.prototype.handleInteraction = function (evt) {
            var isEnter = evt.key === 'Enter' || evt.keyCode === 13;

            if (evt.type === 'click' || isEnter) {
              this.adapter_.notifyInteraction();
            }
          };
          /**
          * Handles a transition end event on the root element.
          */


          MDCChipFoundation.prototype.handleTransitionEnd = function (evt) {
            var _this = this; // Handle transition end event on the chip when it is about to be removed.


            if (this.adapter_.eventTargetHasClass(evt.target, __WEBPACK_IMPORTED_MODULE_2__constants__["a"
            /* cssClasses */
            ].CHIP_EXIT)) {
              if (evt.propertyName === 'width') {
                this.adapter_.notifyRemoval();
              } else if (evt.propertyName === 'opacity') {
                // See: https://css-tricks.com/using-css-transitions-auto-dimensions/#article-header-id-5
                var chipWidth_1 = this.adapter_.getComputedStyleValue('width'); // On the next frame (once we get the computed width), explicitly set the chip's width
                // to its current pixel width, so we aren't transitioning out of 'auto'.

                requestAnimationFrame(function () {
                  _this.adapter_.setStyleProperty('width', chipWidth_1); // To mitigate jitter, start transitioning padding and margin before width.


                  _this.adapter_.setStyleProperty('padding', '0');

                  _this.adapter_.setStyleProperty('margin', '0'); // On the next frame (once width is explicitly set), transition width to 0.


                  requestAnimationFrame(function () {
                    _this.adapter_.setStyleProperty('width', '0');
                  });
                });
              }

              return;
            } // Handle a transition end event on the leading icon or checkmark, since the transition end event bubbles.


            if (evt.propertyName !== 'opacity') {
              return;
            }

            if (this.adapter_.eventTargetHasClass(evt.target, __WEBPACK_IMPORTED_MODULE_2__constants__["a"
            /* cssClasses */
            ].LEADING_ICON) && this.adapter_.hasClass(__WEBPACK_IMPORTED_MODULE_2__constants__["a"
            /* cssClasses */
            ].SELECTED)) {
              this.adapter_.addClassToLeadingIcon(__WEBPACK_IMPORTED_MODULE_2__constants__["a"
              /* cssClasses */
              ].HIDDEN_LEADING_ICON);
            } else if (this.adapter_.eventTargetHasClass(evt.target, __WEBPACK_IMPORTED_MODULE_2__constants__["a"
            /* cssClasses */
            ].CHECKMARK) && !this.adapter_.hasClass(__WEBPACK_IMPORTED_MODULE_2__constants__["a"
            /* cssClasses */
            ].SELECTED)) {
              this.adapter_.removeClassFromLeadingIcon(__WEBPACK_IMPORTED_MODULE_2__constants__["a"
              /* cssClasses */
              ].HIDDEN_LEADING_ICON);
            }
          };
          /**
          * Handles an interaction event on the trailing icon element. This is used to
          * prevent the ripple from activating on interaction with the trailing icon.
          */


          MDCChipFoundation.prototype.handleTrailingIconInteraction = function (evt) {
            var isEnter = evt.key === 'Enter' || evt.keyCode === 13;
            evt.stopPropagation();

            if (evt.type === 'click' || isEnter) {
              this.adapter_.notifyTrailingIconInteraction();

              if (this.shouldRemoveOnTrailingIconClick_) {
                this.beginExit();
              }
            }
          };

          return MDCChipFoundation;
        }(__WEBPACK_IMPORTED_MODULE_1__material_base_foundation__["a"
        /* MDCFoundation */
        ]); // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.

        /* harmony default export */


        __webpack_exports__["default"] = MDCChipFoundation;
        /***/
      },

      /***/
      70:
      /***/
      function _(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        /* harmony export (binding) */

        __webpack_require__.d(__webpack_exports__, "b", function () {
          return strings;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "a", function () {
          return cssClasses;
        });
        /**
         * @license
         * Copyright 2016 Google Inc.
         *
         * Permission is hereby granted, free of charge, to any person obtaining a copy
         * of this software and associated documentation files (the "Software"), to deal
         * in the Software without restriction, including without limitation the rights
         * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
         * copies of the Software, and to permit persons to whom the Software is
         * furnished to do so, subject to the following conditions:
         *
         * The above copyright notice and this permission notice shall be included in
         * all copies or substantial portions of the Software.
         *
         * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
         * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
         * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
         * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
         * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
         * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
         * THE SOFTWARE.
         */


        var strings = {
          CHECKMARK_SELECTOR: '.mdc-chip__checkmark',
          ENTRY_ANIMATION_NAME: 'mdc-chip-entry',
          INTERACTION_EVENT: 'MDCChip:interaction',
          LEADING_ICON_SELECTOR: '.mdc-chip__icon--leading',
          REMOVAL_EVENT: 'MDCChip:removal',
          SELECTION_EVENT: 'MDCChip:selection',
          TRAILING_ICON_INTERACTION_EVENT: 'MDCChip:trailingIconInteraction',
          TRAILING_ICON_SELECTOR: '.mdc-chip__icon--trailing'
        };
        var cssClasses = {
          CHECKMARK: 'mdc-chip__checkmark',
          CHIP_EXIT: 'mdc-chip--exit',
          HIDDEN_LEADING_ICON: 'mdc-chip__icon--leading-hidden',
          LEADING_ICON: 'mdc-chip__icon--leading',
          SELECTED: 'mdc-chip--selected',
          TRAILING_ICON: 'mdc-chip__icon--trailing'
        };
        /***/
      },

      /***/
      71:
      /***/
      function _(module, exports, __webpack_require__) {
        "use strict";

        var __extends = this && this.__extends || function () {
          var _extendStatics4 = function extendStatics(d, b) {
            _extendStatics4 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (d, b) {
              d.__proto__ = b;
            } || function (d, b) {
              for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
            };

            return _extendStatics4(d, b);
          };

          return function (d, b) {
            _extendStatics4(d, b);

            function __() {
              this.constructor = d;
            }

            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }();

        var __rest = this && this.__rest || function (s, e) {
          var t = {};

          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

          if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
          return t;
        };

        var __importDefault = this && this.__importDefault || function (mod) {
          return mod && mod.__esModule ? mod : {
            "default": mod
          };
        };

        Object.defineProperty(exports, "__esModule", {
          value: true
        }); // The MIT License
        //
        // Copyright (c) 2018 Google, Inc.
        //
        // Permission is hereby granted, free of charge, to any person obtaining a copy
        // of this software and associated documentation files (the "Software"), to deal
        // in the Software without restriction, including without limitation the rights
        // to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
        // copies of the Software, and to permit persons to whom the Software is
        // furnished to do so, subject to the following conditions:
        //
        // The above copyright notice and this permission notice shall be included in
        // all copies or substantial portions of the Software.
        //
        // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
        // IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
        // FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
        // AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
        // LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
        // OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
        // THE SOFTWARE.

        var react_1 = __importDefault(__webpack_require__(0));

        var react_is_1 = __webpack_require__(72);

        var classnames_1 = __importDefault(__webpack_require__(1));

        var foundation_1 = __webpack_require__(75);

        var ChipCheckmark_1 = __importDefault(__webpack_require__(33));

        var ChipSet =
        /** @class */
        function (_super) {
          __extends(ChipSet, _super);

          function ChipSet(props) {
            var _this = _super.call(this, props) || this;

            _this.checkmarkWidth = 0;

            _this.handleInteraction = function (chipId) {
              _this.state.foundation.handleChipInteraction(chipId);
            };

            _this.handleSelect = function (chipId, selected) {
              _this.state.foundation.handleChipSelection(chipId, selected);
            };

            _this.handleRemove = function (chipId) {
              _this.state.foundation.handleChipRemoval(chipId);
            };

            _this.removeChip = function (chipId) {
              var _a = _this.props,
                  updateChips = _a.updateChips,
                  children = _a.children;
              if (!children) return;
              var chips = react_1.default.Children.toArray(children).filter(react_is_1.isElement).slice();

              for (var i = 0; i < chips.length; i++) {
                var chip = chips[i];

                if (chip.props.id === chipId) {
                  chips.splice(i, 1);
                  break;
                }
              }

              var chipsArray = chips.length ? chips.map(function (chip) {
                return chip.props;
              }) : [];
              updateChips(chipsArray);
            };

            _this.setCheckmarkWidth = function (checkmark) {
              if (!!_this.checkmarkWidth || !checkmark) {
                return;
              }

              _this.checkmarkWidth = checkmark.width;
            };

            _this.computeBoundingRect = function (chipElement) {
              var _a = chipElement.getBoundingClientRect(),
                  height = _a.height,
                  chipWidth = _a.width;

              var width = chipWidth + _this.checkmarkWidth;
              return {
                height: height,
                width: width
              };
            };

            _this.renderChip = function (chip) {
              if (!chip || !react_is_1.isElement(chip)) return;
              var _a = _this.props,
                  choice = _a.choice,
                  filter = _a.filter,
                  input = _a.input;

              if ((choice || filter || input) && !chip.props.id) {
                throw new Error('Chip variant missing required property: id.');
              }

              var selectedChipIds = _this.state.selectedChipIds;
              var selected = selectedChipIds.indexOf(chip.props.id) > -1;

              var _b = chip.props,
                  _handleInteraction = _b.handleInteraction,
                  _handleSelect = _b.handleSelect,
                  _handleRemove = _b.handleRemove,
                  chipProps = __rest(_b, ["handleInteraction", "handleSelect", "handleRemove"]);

              var props = Object.assign.apply(Object, [{}].concat(chipProps, [{
                selected: selected,
                handleSelect: function handleSelect(id, selected) {
                  _handleSelect(id, selected);

                  _this.handleSelect(id, selected);
                },
                handleInteraction: function handleInteraction(id) {
                  _handleInteraction(id);

                  _this.handleInteraction(id);
                },
                handleRemove: function handleRemove(id) {
                  _handleRemove(id);

                  _this.handleRemove(id);
                },
                chipCheckmark: filter ? react_1.default.createElement(ChipCheckmark_1.default, {
                  ref: _this.setCheckmarkWidth
                }) : null,
                computeBoundingRect: filter ? _this.computeBoundingRect : null
              }]));
              return react_1.default.cloneElement(chip, props);
            };

            _this.state = {
              selectedChipIds: props.selectedChipIds,
              foundation: null,
              hasInitialized: false
            };
            return _this;
          }

          ChipSet.prototype.componentDidMount = function () {
            var foundation = new foundation_1.MDCChipSetFoundation(this.adapter);
            this.setState({
              foundation: foundation
            });
            foundation.init();
          };

          ChipSet.prototype.componentDidUpdate = function (prevProps, prevState) {
            var selectedChipIds = this.props.selectedChipIds;

            if (this.state.foundation !== prevState.foundation) {
              this.initChipSelection();
            }

            if (selectedChipIds !== prevProps.selectedChipIds) {
              this.setState({
                selectedChipIds: selectedChipIds
              });
            }
          };

          ChipSet.prototype.componentWillUnmount = function () {
            this.state.foundation && this.state.foundation.destroy();
          };

          Object.defineProperty(ChipSet.prototype, "classes", {
            get: function get() {
              var _a = this.props,
                  className = _a.className,
                  filter = _a.filter,
                  choice = _a.choice,
                  input = _a.input;
              return classnames_1.default('mdc-chip-set', className, {
                'mdc-chip-set--filter': filter,
                'mdc-chip-set--choice': choice,
                'mdc-chip-set--input': input
              });
            },
            enumerable: true,
            configurable: true
          });
          Object.defineProperty(ChipSet.prototype, "adapter", {
            get: function get() {
              var _this = this;

              return {
                hasClass: function hasClass(className) {
                  return _this.classes.split(' ').includes(className);
                },
                setSelected: function setSelected() {
                  var selectedChipIds = _this.state.foundation.getSelectedChipIds().slice();

                  _this.setState({
                    selectedChipIds: selectedChipIds
                  }, function () {
                    _this.props.handleSelect(selectedChipIds);
                  });
                },
                removeChip: this.removeChip
              };
            },
            enumerable: true,
            configurable: true
          });

          ChipSet.prototype.initChipSelection = function () {
            var _this = this;

            react_1.default.Children.forEach(this.props.children, function (child) {
              if (!child || !react_is_1.isElement(child)) {
                return;
              }

              var id = child.props.id;
              var selected = _this.state.selectedChipIds.indexOf(id) > -1;

              if (selected) {
                _this.state.foundation.select(id);
              }
            });
            this.setState({
              hasInitialized: true
            });
          };

          ChipSet.prototype.render = function () {
            // need foundation on state, because Chip calls a foundation method
            // before ChipSet mounts.
            if (!this.state.hasInitialized) return null;
            return react_1.default.createElement("div", {
              className: this.classes
            }, react_1.default.Children.map(this.props.children, this.renderChip));
          };

          ChipSet.defaultProps = {
            className: '',
            selectedChipIds: [],
            handleSelect: function handleSelect() {},
            updateChips: function updateChips() {},
            choice: false,
            filter: false,
            input: false
          };
          return ChipSet;
        }(react_1.default.Component);

        exports.default = ChipSet;
        /***/
      },

      /***/
      72:
      /***/
      function _(module, exports, __webpack_require__) {
        "use strict";
        /* WEBPACK VAR INJECTION */

        (function (process) {
          if (process.env.NODE_ENV === 'production') {
            module.exports = __webpack_require__(73);
          } else {
            module.exports = __webpack_require__(74);
          }
          /* WEBPACK VAR INJECTION */

        }).call(exports, __webpack_require__(34));
        /***/
      },

      /***/
      73:
      /***/
      function _(module, exports, __webpack_require__) {
        "use strict";
        /** @license React v16.8.6
         * react-is.production.min.js
         *
         * Copyright (c) Facebook, Inc. and its affiliates.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */

        var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
          return typeof obj;
        } : function (obj) {
          return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };

        Object.defineProperty(exports, "__esModule", {
          value: !0
        });
        var b = "function" === typeof Symbol && Symbol.for,
            c = b ? Symbol.for("react.element") : 60103,
            d = b ? Symbol.for("react.portal") : 60106,
            e = b ? Symbol.for("react.fragment") : 60107,
            f = b ? Symbol.for("react.strict_mode") : 60108,
            g = b ? Symbol.for("react.profiler") : 60114,
            h = b ? Symbol.for("react.provider") : 60109,
            k = b ? Symbol.for("react.context") : 60110,
            l = b ? Symbol.for("react.async_mode") : 60111,
            m = b ? Symbol.for("react.concurrent_mode") : 60111,
            n = b ? Symbol.for("react.forward_ref") : 60112,
            p = b ? Symbol.for("react.suspense") : 60113,
            q = b ? Symbol.for("react.memo") : 60115,
            r = b ? Symbol.for("react.lazy") : 60116;

        function t(a) {
          if ("object" === (typeof a === "undefined" ? "undefined" : _typeof(a)) && null !== a) {
            var u = a.$$typeof;

            switch (u) {
              case c:
                switch (a = a.type, a) {
                  case l:
                  case m:
                  case e:
                  case g:
                  case f:
                  case p:
                    return a;

                  default:
                    switch (a = a && a.$$typeof, a) {
                      case k:
                      case n:
                      case h:
                        return a;

                      default:
                        return u;
                    }

                }

              case r:
              case q:
              case d:
                return u;
            }
          }
        }

        function v(a) {
          return t(a) === m;
        }

        exports.typeOf = t;
        exports.AsyncMode = l;
        exports.ConcurrentMode = m;
        exports.ContextConsumer = k;
        exports.ContextProvider = h;
        exports.Element = c;
        exports.ForwardRef = n;
        exports.Fragment = e;
        exports.Lazy = r;
        exports.Memo = q;
        exports.Portal = d;
        exports.Profiler = g;
        exports.StrictMode = f;
        exports.Suspense = p;

        exports.isValidElementType = function (a) {
          return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || "object" === (typeof a === "undefined" ? "undefined" : _typeof(a)) && null !== a && (a.$$typeof === r || a.$$typeof === q || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n);
        };

        exports.isAsyncMode = function (a) {
          return v(a) || t(a) === l;
        };

        exports.isConcurrentMode = v;

        exports.isContextConsumer = function (a) {
          return t(a) === k;
        };

        exports.isContextProvider = function (a) {
          return t(a) === h;
        };

        exports.isElement = function (a) {
          return "object" === (typeof a === "undefined" ? "undefined" : _typeof(a)) && null !== a && a.$$typeof === c;
        };

        exports.isForwardRef = function (a) {
          return t(a) === n;
        };

        exports.isFragment = function (a) {
          return t(a) === e;
        };

        exports.isLazy = function (a) {
          return t(a) === r;
        };

        exports.isMemo = function (a) {
          return t(a) === q;
        };

        exports.isPortal = function (a) {
          return t(a) === d;
        };

        exports.isProfiler = function (a) {
          return t(a) === g;
        };

        exports.isStrictMode = function (a) {
          return t(a) === f;
        };

        exports.isSuspense = function (a) {
          return t(a) === p;
        };
        /***/

      },

      /***/
      74:
      /***/
      function _(module, exports, __webpack_require__) {
        "use strict";
        /* WEBPACK VAR INJECTION */

        (function (process) {
          /** @license React v16.8.6
          * react-is.development.js
          *
          * Copyright (c) Facebook, Inc. and its affiliates.
          *
          * This source code is licensed under the MIT license found in the
          * LICENSE file in the root directory of this source tree.
          */
          var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
            return typeof obj;
          } : function (obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
          };

          if (process.env.NODE_ENV !== "production") {
            (function () {
              'use strict';

              Object.defineProperty(exports, '__esModule', {
                value: true
              }); // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
              // nor polyfill, then a plain number is used for performance.

              var hasSymbol = typeof Symbol === 'function' && Symbol.for;
              var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
              var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
              var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
              var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
              var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
              var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
              var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace;
              var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
              var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
              var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
              var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
              var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
              var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;

              function isValidElementType(type) {
                return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
                type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || (typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE);
              }
              /**
              * Forked from fbjs/warning:
              * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
              *
              * Only change is we use console.warn instead of console.error,
              * and do nothing when 'console' is not supported.
              * This really simplifies the code.
              * ---
              * Similar to invariant but only logs a warning if the condition is not met.
              * This can be used to log issues in development environments in critical
              * paths. Removing the logging code for production environments will keep the
              * same logic and follow the same code paths.
              */


              var lowPriorityWarning = function lowPriorityWarning() {};

              {
                var printWarning = function printWarning(format) {
                  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                    args[_key - 1] = arguments[_key];
                  }

                  var argIndex = 0;
                  var message = 'Warning: ' + format.replace(/%s/g, function () {
                    return args[argIndex++];
                  });

                  if (typeof console !== 'undefined') {
                    console.warn(message);
                  }

                  try {
                    // --- Welcome to debugging React ---
                    // This error was thrown as a convenience so that you can use this stack
                    // to find the callsite that caused this warning to fire.
                    throw new Error(message);
                  } catch (x) {}
                };

                lowPriorityWarning = function lowPriorityWarning(condition, format) {
                  if (format === undefined) {
                    throw new Error('`lowPriorityWarning(condition, format, ...args)` requires a warning ' + 'message argument');
                  }

                  if (!condition) {
                    for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
                      args[_key2 - 2] = arguments[_key2];
                    }

                    printWarning.apply(undefined, [format].concat(args));
                  }
                };
              }
              var lowPriorityWarning$1 = lowPriorityWarning;

              function typeOf(object) {
                if ((typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && object !== null) {
                  var $$typeof = object.$$typeof;

                  switch ($$typeof) {
                    case REACT_ELEMENT_TYPE:
                      var type = object.type;

                      switch (type) {
                        case REACT_ASYNC_MODE_TYPE:
                        case REACT_CONCURRENT_MODE_TYPE:
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                          return type;

                        default:
                          var $$typeofType = type && type.$$typeof;

                          switch ($$typeofType) {
                            case REACT_CONTEXT_TYPE:
                            case REACT_FORWARD_REF_TYPE:
                            case REACT_PROVIDER_TYPE:
                              return $$typeofType;

                            default:
                              return $$typeof;
                          }

                      }

                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PORTAL_TYPE:
                      return $$typeof;
                  }
                }

                return undefined;
              } // AsyncMode is deprecated along with isAsyncMode


              var AsyncMode = REACT_ASYNC_MODE_TYPE;
              var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
              var ContextConsumer = REACT_CONTEXT_TYPE;
              var ContextProvider = REACT_PROVIDER_TYPE;
              var Element = REACT_ELEMENT_TYPE;
              var ForwardRef = REACT_FORWARD_REF_TYPE;
              var Fragment = REACT_FRAGMENT_TYPE;
              var Lazy = REACT_LAZY_TYPE;
              var Memo = REACT_MEMO_TYPE;
              var Portal = REACT_PORTAL_TYPE;
              var Profiler = REACT_PROFILER_TYPE;
              var StrictMode = REACT_STRICT_MODE_TYPE;
              var Suspense = REACT_SUSPENSE_TYPE;
              var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

              function isAsyncMode(object) {
                {
                  if (!hasWarnedAboutDeprecatedIsAsyncMode) {
                    hasWarnedAboutDeprecatedIsAsyncMode = true;
                    lowPriorityWarning$1(false, 'The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
                  }
                }
                return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
              }

              function isConcurrentMode(object) {
                return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
              }

              function isContextConsumer(object) {
                return typeOf(object) === REACT_CONTEXT_TYPE;
              }

              function isContextProvider(object) {
                return typeOf(object) === REACT_PROVIDER_TYPE;
              }

              function isElement(object) {
                return (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
              }

              function isForwardRef(object) {
                return typeOf(object) === REACT_FORWARD_REF_TYPE;
              }

              function isFragment(object) {
                return typeOf(object) === REACT_FRAGMENT_TYPE;
              }

              function isLazy(object) {
                return typeOf(object) === REACT_LAZY_TYPE;
              }

              function isMemo(object) {
                return typeOf(object) === REACT_MEMO_TYPE;
              }

              function isPortal(object) {
                return typeOf(object) === REACT_PORTAL_TYPE;
              }

              function isProfiler(object) {
                return typeOf(object) === REACT_PROFILER_TYPE;
              }

              function isStrictMode(object) {
                return typeOf(object) === REACT_STRICT_MODE_TYPE;
              }

              function isSuspense(object) {
                return typeOf(object) === REACT_SUSPENSE_TYPE;
              }

              exports.typeOf = typeOf;
              exports.AsyncMode = AsyncMode;
              exports.ConcurrentMode = ConcurrentMode;
              exports.ContextConsumer = ContextConsumer;
              exports.ContextProvider = ContextProvider;
              exports.Element = Element;
              exports.ForwardRef = ForwardRef;
              exports.Fragment = Fragment;
              exports.Lazy = Lazy;
              exports.Memo = Memo;
              exports.Portal = Portal;
              exports.Profiler = Profiler;
              exports.StrictMode = StrictMode;
              exports.Suspense = Suspense;
              exports.isValidElementType = isValidElementType;
              exports.isAsyncMode = isAsyncMode;
              exports.isConcurrentMode = isConcurrentMode;
              exports.isContextConsumer = isContextConsumer;
              exports.isContextProvider = isContextProvider;
              exports.isElement = isElement;
              exports.isForwardRef = isForwardRef;
              exports.isFragment = isFragment;
              exports.isLazy = isLazy;
              exports.isMemo = isMemo;
              exports.isPortal = isPortal;
              exports.isProfiler = isProfiler;
              exports.isStrictMode = isStrictMode;
              exports.isSuspense = isSuspense;
            })();
          }
          /* WEBPACK VAR INJECTION */

        }).call(exports, __webpack_require__(34));
        /***/
      },

      /***/
      75:
      /***/
      function _(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        Object.defineProperty(__webpack_exports__, "__esModule", {
          value: true
        });
        /* harmony export (binding) */

        __webpack_require__.d(__webpack_exports__, "MDCChipSetFoundation", function () {
          return MDCChipSetFoundation;
        });
        /* harmony import */


        var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(31);
        /* harmony import */


        var __WEBPACK_IMPORTED_MODULE_1__material_base_foundation__ = __webpack_require__(32);
        /* harmony import */


        var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(76);
        /**
         * @license
         * Copyright 2017 Google Inc.
         *
         * Permission is hereby granted, free of charge, to any person obtaining a copy
         * of this software and associated documentation files (the "Software"), to deal
         * in the Software without restriction, including without limitation the rights
         * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
         * copies of the Software, and to permit persons to whom the Software is
         * furnished to do so, subject to the following conditions:
         *
         * The above copyright notice and this permission notice shall be included in
         * all copies or substantial portions of the Software.
         *
         * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
         * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
         * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
         * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
         * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
         * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
         * THE SOFTWARE.
         */


        var MDCChipSetFoundation =
        /** @class */
        function (_super) {
          __WEBPACK_IMPORTED_MODULE_0_tslib__["b"
          /* __extends */
          ](MDCChipSetFoundation, _super);

          function MDCChipSetFoundation(adapter) {
            var _this = _super.call(this, __WEBPACK_IMPORTED_MODULE_0_tslib__["a"
            /* __assign */
            ]({}, MDCChipSetFoundation.defaultAdapter, adapter)) || this;
            /**
            * The ids of the selected chips in the set. Only used for choice chip set or filter chip set.
            */


            _this.selectedChipIds_ = [];
            return _this;
          }

          Object.defineProperty(MDCChipSetFoundation, "strings", {
            get: function get() {
              return __WEBPACK_IMPORTED_MODULE_2__constants__["b"
              /* strings */
              ];
            },
            enumerable: true,
            configurable: true
          });
          Object.defineProperty(MDCChipSetFoundation, "cssClasses", {
            get: function get() {
              return __WEBPACK_IMPORTED_MODULE_2__constants__["a"
              /* cssClasses */
              ];
            },
            enumerable: true,
            configurable: true
          });
          Object.defineProperty(MDCChipSetFoundation, "defaultAdapter", {
            get: function get() {
              return {
                hasClass: function hasClass() {
                  return false;
                },
                removeChip: function removeChip() {
                  return undefined;
                },
                setSelected: function setSelected() {
                  return undefined;
                }
              };
            },
            enumerable: true,
            configurable: true
          });
          /**
          * Returns an array of the IDs of all selected chips.
          */

          MDCChipSetFoundation.prototype.getSelectedChipIds = function () {
            return this.selectedChipIds_.slice();
          };
          /**
          * Selects the chip with the given id. Deselects all other chips if the chip set is of the choice variant.
          */


          MDCChipSetFoundation.prototype.select = function (chipId) {
            if (this.selectedChipIds_.indexOf(chipId) >= 0) {
              return;
            }

            if (this.adapter_.hasClass(__WEBPACK_IMPORTED_MODULE_2__constants__["a"
            /* cssClasses */
            ].CHOICE) && this.selectedChipIds_.length > 0) {
              var previouslySelectedChip = this.selectedChipIds_[0];
              this.selectedChipIds_.length = 0;
              this.adapter_.setSelected(previouslySelectedChip, false);
            }

            this.selectedChipIds_.push(chipId);
            this.adapter_.setSelected(chipId, true);
          };
          /**
          * Handles a chip interaction event
          */


          MDCChipSetFoundation.prototype.handleChipInteraction = function (chipId) {
            if (this.adapter_.hasClass(__WEBPACK_IMPORTED_MODULE_2__constants__["a"
            /* cssClasses */
            ].CHOICE) || this.adapter_.hasClass(__WEBPACK_IMPORTED_MODULE_2__constants__["a"
            /* cssClasses */
            ].FILTER)) {
              this.toggleSelect_(chipId);
            }
          };
          /**
          * Handles a chip selection event, used to handle discrepancy when selection state is set directly on the Chip.
          */


          MDCChipSetFoundation.prototype.handleChipSelection = function (chipId, selected) {
            var chipIsSelected = this.selectedChipIds_.indexOf(chipId) >= 0;

            if (selected && !chipIsSelected) {
              this.select(chipId);
            } else if (!selected && chipIsSelected) {
              this.deselect_(chipId);
            }
          };
          /**
          * Handles the event when a chip is removed.
          */


          MDCChipSetFoundation.prototype.handleChipRemoval = function (chipId) {
            this.deselect_(chipId);
            this.adapter_.removeChip(chipId);
          };
          /**
          * Deselects the chip with the given id.
          */


          MDCChipSetFoundation.prototype.deselect_ = function (chipId) {
            var index = this.selectedChipIds_.indexOf(chipId);

            if (index >= 0) {
              this.selectedChipIds_.splice(index, 1);
              this.adapter_.setSelected(chipId, false);
            }
          };
          /**
          * Toggles selection of the chip with the given id.
          */


          MDCChipSetFoundation.prototype.toggleSelect_ = function (chipId) {
            if (this.selectedChipIds_.indexOf(chipId) >= 0) {
              this.deselect_(chipId);
            } else {
              this.select(chipId);
            }
          };

          return MDCChipSetFoundation;
        }(__WEBPACK_IMPORTED_MODULE_1__material_base_foundation__["a"
        /* MDCFoundation */
        ]); // tslint:disable-next-line:no-default-export Needed for backward compatibility with MDC Web v0.44.0 and earlier.

        /* harmony default export */


        __webpack_exports__["default"] = MDCChipSetFoundation;
        /***/
      },

      /***/
      76:
      /***/
      function _(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        /* harmony export (binding) */

        __webpack_require__.d(__webpack_exports__, "b", function () {
          return strings;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "a", function () {
          return cssClasses;
        });
        /**
         * @license
         * Copyright 2016 Google Inc.
         *
         * Permission is hereby granted, free of charge, to any person obtaining a copy
         * of this software and associated documentation files (the "Software"), to deal
         * in the Software without restriction, including without limitation the rights
         * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
         * copies of the Software, and to permit persons to whom the Software is
         * furnished to do so, subject to the following conditions:
         *
         * The above copyright notice and this permission notice shall be included in
         * all copies or substantial portions of the Software.
         *
         * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
         * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
         * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
         * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
         * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
         * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
         * THE SOFTWARE.
         */


        var strings = {
          CHIP_SELECTOR: '.mdc-chip'
        };
        var cssClasses = {
          CHOICE: 'mdc-chip-set--choice',
          FILTER: 'mdc-chip-set--filter'
        };
        /***/
      }
      /******/

    })
  );
});